<div class="d-flex flex-column">
	<div class="d-flex">
		<div class="h4">{{ venueSelected.name }}</div>
	</div>
	<div class="d-flex w-100">
		<div class="p-grid w-100">
			<div class="col-6">FocusON Licenses: {{ venueSelected.financial.counts.onOrderLicenses + venueSelected.financial.counts.onPayLicenses }}</div>
			<div class="col-6">Kitchen Licenses: {{ venueSelected.financial.counts.kitchen }}</div>
		</div>
	</div>
</div>
